{
  "notes": "Notes",
  "notes-empty": "Add notes.",
  "immediate-family": "Immediate Family",
  "immediate-family-empty": "Add immediate family",
  "family-age": ", Age {{age}}",
  "family-age-months": ", Age {{age}} Months",
  "net-worth-progress": "Net Worth Progress",
  "annual-spending": "Annual Spending*",
  "personal-financial-statement": "Personal Financial Statement",
  "total-assets": "Total Assets",
  "total-debts": "Total Debts",
  "remove-app-access": "Remove App Access",
  "invitation-sent": "Invitation sent {{when}}",
  "mark-onboarding-as-completed": "Mark Onboarding as Completed",
  "onboarding-banner-body": "We’ll hold off on calculating progress in reports until you let us know {{- name}} {{isAre}} fully onboarded.",
  "remove-access-modal-ok": "Remove Access",
  "remove-access-modal-title": "Remove Client Access to Elements?",
  "remove-access-modal-body": "By removing client access to Elements they will no longer be able to access the Elements app.",
  "resend-invitation-body": "Verify the email addresses below and resend the invitation to {{- who}} to join you on Elements.",
  "important-people": "Important People",
  "other-relationship": "Other Relationships",
  "create-one-page-plan": "Create One-Page Plan",
  "one-page-plan-banner-text": "Don't forget—creating a One Page Plan for your client is a great way to help them stay focused and make progress.",
  "edit-financial-purpose-meta-title": "Edit the client's financial purpose",
  "edit-financial-purpose-heading": "Edit Financial Purpose",
  "edit-financial-purpose-placeholder": "Add your client’s financial purpose here...",
  "edit-goals-heading": "Edit Goals",
  "edit-goals-meta-title": "Create, edit, and delete financial goals for this client",
  "client-goals-empty": "Add client goals.",
  "client-next-steps-empty": "Add tasks.",
  "edit-next-steps-meta-title": "Create, edit, and delete tasks for this client",
  "edit-next-steps-heading": "Edit Tasks",
  "add-individual": "Add Individual",
  "edit-individual": "Edit Individual",
  "remove-individual-modal-title": "Remove Individual?",
  "remove-individual-modal-body": "Removing this person will delete them from your client’s profile and they will lose their access to the Elements app. Additionally, any assets or debts assigned to them will revert their ownership back to the primary head-of-household. This action cannot be undone.",
  "remove-individual-modal-ok": "Remove Individual",
  "prospect-banner-body_one": "{{- name}} is a prospect. Convert this prospect to a client to move them to your “Onboarding Group”",
  "prospect-banner-body_other": "{{- name}} are prospects. Convert them to a client to move them to your “Onboarding Group”.",
  "include-debt-payments": "*include debt payments",
  "remove-client": "Remove Client",
  "remove-client-modal-title": "Remove Client?",
  "remove-client-modal-body": "Removing a client will delete them from your list of clients and cannot be undone.",
  "remove-client-notification": "You have removed {{- user}} from your client list.",
  "decayed-percentage": "{{- percentage}}% of balances are decayed",

  "client-page-household-income-button-label": "Household Income",
  "client-page-annual-spending-button-label": "Annual Spending",
  "client-page-scorecard-button-no-report": "Report unavailable",
  "client-page-scorecard-full-screen-button": "Full Screen",
  "client-details-tab-overview": "Overview",
  "client-details-tab-accounts": "Accounts",
  "client-details-tab-tasks-goals": "Tasks & Goals",
  "client-details-tab-documents-estate": "Documents",
  "client-details-download-progress-report": "Download Progress Report",
  "client-details-download-pfs-report": "Download Personal Financial Statement",
  "client-details-open-one-page-plan": "Open One-Page Plan",
  "client-details-documents-heading": "Documents",
  "client-details-documents-client-uploads-heading": "Client Uploads",
  "client-details-documents-uploaded-heading": "Uploaded Documents",
  "client-details-upload-document": "Upload Document",
  "client-details-documents-search-placeholder": "Search document titles",
  "client-details-documents-search-empty": "No documents match this search.",
  "client-details-documents-empty": "No uploaded documents yet.",
  "client-details-document-delete-success": "“{{- fileName}}” was deleted.",
  "client-details-documents-loading": "Loading documents...",
  "client-details-documents-error": "Documents could not be loaded.",
  "client-details-documents-retry": "Retry",
  "client-details-documents-unavailable": "Documents are not enabled.",
  "client-details-documents-source-client-upload": "Client Upload",
  "client-details-documents-source-general": "General",
  "client-details-documents-more-sources": "+{{count}} more",
  "client-details-documents-source-accounts": "Accounts",
  "client-details-documents-source-business": "Business",
  "client-details-documents-source-real-estate": "Real Estate",
  "client-details-documents-source-notes": "Notes",
  "client-details-documents-source-property": "Property",
  "client-details-documents-source-debts": "Debts",
  "household-elements-customization-link-label": "Customize Elements",
  "household-elements-customization-description": "Choose which Elements are visible for this household.",
  "household-elements-customization-disabled-message": "Customize Elements is not enabled for this firm yet.",
  "household-elements-customization-firm-setting": "Firm setting",
  "household-elements-customization-show": "Show",
  "household-elements-customization-hide": "Hide",
  "household-elements-customization-visible-by-firm": "Visible by firm setting",
  "household-elements-customization-hidden-by-firm": "Hidden by firm setting",
  "household-elements-customization-shown-by-household": "Shown for this household",
  "household-elements-customization-hidden-by-household": "Hidden for this household",
  "household-element-customization-save-success": "Household Element visibility updated.",
  "household-element-customization-save-error": "Unable to update household Element visibility.",

  "income-page-heading": "Income & Spending",
  "income-page-description": "Manage household income sources and spending estimates here.",
  "income-page-empty-description": "Add your household income sources to estimate the amount you expect to earn during the current year.",
  "income-page-segmented-control-income": "Income Sources",
  "income-page-segmented-control-spending": "Spending",
  "income-page-add-income-source-button": "Add Income Source",
  "income-page-total-income-row-title": "Total Household Income",

  "spending-page-description": "Make sure to include all debt payments (currently {{- debtPaymentsDisplay}} {{- frequencySuffix}}) in this estimate.  We'll back out the Debt Payments from Burn Rate so they don't get double counted with Debt Rate too.",
  "spending-page-form-spending-amount-input-label": "Estimated Spending",

  "report-preview-page-action-button": "Download Report",
  "report-preview-page-report-name": "{{- givenName}} {{- familyName}}'s {{reportTypeDisplay}} ({{dateDisplay}})",
  "report-preview-error-page-modal-title": "Hmmmm...",
  "report-preview-error-page-modal-body": "Looks like we’re having trouble loading that report right now. Try again later. If this is happening to you frequently, contact us to help get to the bottom of this error.",
  "report-preview-error-page-modal-primary-action": "Contact Us",

  "download-element-report": "Download {{element}} Report",
  "estate-status-report-name": "Estate Status Report",
  "download-report": "Download Report",
  "coverage-review-entry-action": "Review coverage",
  "coverage-review-entry-description": "Confirm policies and discuss protection",
  "coverage-review-title": "Coverage Review",
  "coverage-review-back-action": "Return to Insurance",
  "coverage-review-preview-status": "UI preview",
  "coverage-review-preview-disclosure": "UI preview · fictional data · not from client records",
  "coverage-review-documents-ready": "2 documents analyzed",
  "coverage-review-progress-label": "Coverage review progress",
  "coverage-review-stage-collect": "Collect",
  "coverage-review-stage-extract": "Extract",
  "coverage-review-stage-confirm": "Confirm",
  "coverage-review-stage-discuss": "Discuss",
  "coverage-review-stage-summary": "Summary",
  "coverage-review-confirm-kicker": "Confirm extracted coverage",
  "coverage-review-confirm-heading": "Does this match the source?",
  "coverage-review-confirm-subheading": "Review the facts Elements found before discussing coverage.",
  "coverage-review-add-documents": "Add documents",
  "coverage-review-add-documents-title": "Add insurance documents",
  "coverage-review-add-documents-description": "PDFs, screenshots, photos, and benefit summaries",
  "coverage-review-choose-documents": "Choose files",
  "coverage-review-document-preview-only": "Files chosen here are not uploaded or analyzed in this UI preview.",
  "coverage-review-files-selected": "{{count}} files selected for review",
  "coverage-review-add-estimate": "Add estimated coverage",
  "coverage-review-add-estimate-title": "Add coverage without a document",
  "coverage-review-add-estimate-description": "Use an advisor estimate when the policy document is unavailable. Estimates remain visibly labeled.",
  "coverage-review-estimate-name": "Coverage name",
  "coverage-review-estimate-type": "Coverage type",
  "coverage-review-estimate-amount": "Estimated coverage amount",
  "coverage-review-estimate-insured": "Person covered",
  "coverage-review-add-estimate-action": "Add estimate",
  "coverage-review-close": "Close",
  "coverage-review-source-preview": "Source document preview",
  "coverage-review-page-count": "Page {{page}}",
  "coverage-review-highlighted-source": "Matched source",
  "coverage-review-source-coverage-amount": "Coverage amount",
  "coverage-review-source-monthly-premium": "Monthly premium",
  "coverage-review-extracted-facts": "Extracted coverage",
  "coverage-review-needs-review": "Needs review",
  "coverage-review-ready-to-confirm": "Ready to confirm",
  "coverage-review-extracted": "Extracted",
  "coverage-review-advisor-corrected": "Advisor corrected",
  "coverage-review-source-original-amount": "Source showed {{amount}}",
  "coverage-review-confirmed": "Confirmed",
  "coverage-review-estimated": "Advisor estimate",
  "coverage-review-correct": "Correct",
  "coverage-review-correct-amount": "Correct coverage amount",
  "coverage-review-save-correction": "Save correction",
  "coverage-review-view-source": "View source",
  "coverage-review-privacy-action": "Document privacy",
  "coverage-review-privacy-title": "Document privacy and retention",
  "coverage-review-privacy-body": "This preview does not upload, retain, or analyze files. Production retention and deletion controls require approval before document analysis ships.",
  "coverage-review-privacy-confirmation": "Advisors will confirm extracted facts before they affect a recommendation.",
  "coverage-review-production-boundary": "Production file handling, access, and deletion behavior are not part of this UI preview.",
  "coverage-review-confirm-action": "Confirm and discuss coverage",
  "coverage-review-estimate-no-source": "Advisor estimate · no source document",
  "coverage-review-estimate-no-source-help": "This amount was entered by the advisor and remains separate from document-extracted coverage.",
  "coverage-review-live-meeting-sheet": "Client conversation",
  "coverage-review-discuss-heading": "What should this household protect?",
  "coverage-review-discuss-subheading": "Adjust the few assumptions that matter. Elements explains why the recommendation changes.",
  "coverage-review-confirmed-policies": "Coverage being discussed",
  "coverage-review-policy-source-counts": "{{confirmed}} confirmed · {{estimated}} estimated",
  "coverage-review-insured-party": "Insured party",
  "coverage-review-policy-type": "Policy",
  "coverage-review-policy-coverage": "Coverage",
  "coverage-review-policy-source": "Source",
  "coverage-review-coverage-types": "Coverage types",
  "coverage-review-life": "Life",
  "coverage-review-disability": "Disability",
  "coverage-review-liability": "Liability",
  "coverage-review-person-protected": "Person being protected",
  "coverage-review-person-protected-help": "Life and disability coverage are reviewed for one insured person at a time.",
  "coverage-review-years-income": "Years of income to protect",
  "coverage-review-years-income-help": "How long should the household have time to adjust?",
  "coverage-review-protect-years": "{{years}} years",
  "coverage-review-family-support": "Family support horizon",
  "coverage-review-family-support-help": "How long should education and dependent support continue?",
  "coverage-review-support-high-school": "Through high school",
  "coverage-review-support-college": "Through college",
  "coverage-review-support-extended": "College plus extended support",
  "coverage-review-debt-to-cover": "Debt to pay off",
  "coverage-review-debt-to-cover-help": "Which obligations should insurance remove from the household?",
  "coverage-review-debt-mortgage": "Mortgage only · $365,000",
  "coverage-review-debt-mortgage-auto": "Mortgage and auto · $410,000",
  "coverage-review-debt-all": "All household debt · $486,000",
  "coverage-review-assets-available": "Assets available to help",
  "coverage-review-assets-available-help": "Which liquid assets could responsibly reduce the need?",
  "coverage-review-assets-none": "Do not count assets",
  "coverage-review-assets-liquid": "Liquid savings · $85,000",
  "coverage-review-assets-expanded": "Savings and taxable assets · $151,000",
  "coverage-review-income-reliance": "Reliance on earned income",
  "coverage-review-income-reliance-help": "How difficult would it be to replace this person's income?",
  "coverage-review-reliance-shared": "Income is shared",
  "coverage-review-reliance-high": "Household relies heavily on it",
  "coverage-review-reliance-essential": "Income and expertise are essential",
  "coverage-review-household-exposure": "Household liability exposure",
  "coverage-review-household-exposure-help": "Consider assets, vehicles, property, and professional visibility.",
  "coverage-review-exposure-standard": "Standard household exposure",
  "coverage-review-exposure-elevated": "Elevated assets or visibility",
  "coverage-review-exposure-complex": "Complex property or business exposure",
  "coverage-review-current-coverage": "Current coverage",
  "coverage-review-recommended-coverage": "Recommended coverage",
  "coverage-review-gap": "Coverage gap",
  "coverage-review-surplus": "Coverage surplus",
  "coverage-review-comparison": "Current and recommended coverage comparison",
  "coverage-review-life-baseline-explanation": "The recommendation protects 8 years of income, family support through college, and the mortgage and auto loan.",
  "coverage-review-change-increases": "increases",
  "coverage-review-change-reduces": "reduces",
  "coverage-review-life-change-explanation": "Protecting {{years}} years of income instead of 8 {{direction}} the recommendation by {{amount}}.",
  "coverage-review-life-family-change-explanation": "The selected family support horizon {{direction}} the recommendation by {{amount}}.",
  "coverage-review-life-debt-change-explanation": "The selected debt payoff choice {{direction}} the recommendation by {{amount}}.",
  "coverage-review-life-assets-change-explanation": "The assets available to help {{direction}} the recommendation by {{amount}}.",
  "coverage-review-life-multiple-change-explanation": "These planning choices {{direction}} the recommendation by {{amount}}.",
  "coverage-review-disability-baseline-explanation": "The recommendation assumes the household relies heavily on this person's earned income.",
  "coverage-review-disability-change-explanation": "The selected income reliance {{direction}} the recommendation by {{amount}}.",
  "coverage-review-liability-baseline-explanation": "The recommendation reflects elevated household assets or visibility.",
  "coverage-review-liability-change-explanation": "The selected liability exposure {{direction}} the recommendation by {{amount}}.",
  "coverage-review-back-to-confirmation": "Back to policy confirmation",
  "coverage-review-summary-action": "Create review summary",
  "coverage-review-summary-title": "Coverage review summary",
  "coverage-review-summary-reviewed-on": "Reviewed {{date}}",
  "coverage-review-summary-confirmed": "Confirmed from documents",
  "coverage-review-summary-confirmed-count": "{{count}} policy facts confirmed",
  "coverage-review-summary-corrected-count": "{{count}} advisor corrections preserved",
  "coverage-review-summary-estimated": "Advisor estimates",
  "coverage-review-summary-estimated-count": "{{count}} estimates used in this review",
  "coverage-review-summary-estimated-none": "No advisor estimates were used.",
  "coverage-review-summary-coverage-decisions": "Coverage decisions",
  "coverage-review-coverage-area": "Coverage area",
  "coverage-review-summary-planning-decisions": "Planning decisions",
  "coverage-review-summary-income-years": "Protect {{years}} years of income",
  "coverage-review-summary-family-support": "Family support: {{value}}",
  "coverage-review-summary-income-reliance": "Income reliance: {{value}}",
  "coverage-review-summary-liability-exposure": "Liability exposure: {{value}}",
  "coverage-review-summary-follow-ups": "Follow-ups",
  "coverage-review-follow-up-employer-benefits": "Request the current employer benefits statement.",
  "coverage-review-follow-up-policy-language": "Review exclusions, riders, and policy language before making a recommendation.",
  "coverage-review-follow-up-assumptions": "Revisit protection assumptions after the client conversation.",
  "coverage-review-summary-unsaved": "No client records were changed.",
  "add-to-client-group": "Add to Group...",
  "remove-all-custom-groups": "Remove from All",
  "client-groups-move-to-group": "{{- name}} moved to \"{{- group}}\"",
  "client-groups-removed-from-group": "{{- name}} removed from \"{{- group}}\"",

  "ai-assessment": {
    "invite-link": {
      "toggle-disclaimer": {
        "on": "Clients who onboard with this link will automatically be directed to an AI generated assessment at the end of onboarding.",
        "off": "Clients who onboard with this link will be directed to their Elements Scorecard or their custom assessment, if present, after onboarding."
      }
    },
    "client-options": {
      "toggle-disclaimer": {
        "on": "This client will be able to access and regenerate an AI assessment on their own",
        "off": "This client can only access assessments that have been manually edited and published by their advisor"
      }
    }
  }
}
